<template>
  <div class="index-top-item-wrap">
    <div class="idnex-search-wrap">
      <span class="title">专利检索分析</span>
      <span>
        <a-radio-group v-model="value" @change="onChange" size="small">
          <a-radio :value="1"> 本校 </a-radio>
          <a-radio :value="2"> 国内 </a-radio>
          <a-radio :value="3"> 全球 </a-radio>
        </a-radio-group>
      </span>
    </div>
    <a-input-search
      placeholder="一键快捷专利检索"
      :maxLength="426"
      v-model="searchValue"
      @search="onSearch"
    >
      <div slot="prefix">
        <IconWrap
          :width="25"
          :height="25"
          url="/static/homeIcon/yilogo.png"
        ></IconWrap>
      </div>
      <span slot="enterButton" class="search-wrap">
        <IconWrap
          :width="25"
          :height="25"
          url="/static/homeIcon/search.png"
        ></IconWrap>
      </span>
    </a-input-search>
    <div class="major-search">
      <span @click="handleMajorSearch">高级检索></span>
    </div>
    <div class="index-content-wrap">
      <div class="content-item">
        <span class="content-title">
          <IconWrap
            :width="20"
            :height="19"
            url="/static/homeIcon/panduan.png"
          ></IconWrap>
          专利服务
        </span>
        <div class="content-detail">
          <div v-for="item in serviceList" :key="item.id">
            <span @click="handleClick(item.id)">{{ item.title }}</span>
          </div>
        </div>
        <!-- <div class="content-more-1"
             @click="moreClick">
          <label>更多></label>
        </div> -->
      </div>
      <div class="content-item">
        <span class="content-title">
          <IconWrap
            :width="20"
            :height="19"
            url="/static/homeIcon/genzhong.png"
          ></IconWrap>
          专利资源
        </span>
        <div class="content-detail">
          <div v-for="item in analysisList" :key="item.id">
            <span @click="patentHandleClick(item.id)">{{ item.title }}</span>
          </div>
        </div>
        <!-- <div class="content-more-2"
             @click="moreClick">
          <label>更多></label>
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
const regV = /&|=/;
const Pat = process.env.VUE_APP_BASE_PAT; //一专利
import { serviceList, analysisList } from "./configs/config.js";
import { getPatyeeToken } from "@/api/back.js";
import { mapState } from "vuex";
export default {
  data() {
    return {
      serviceList,
      analysisList,
      value: 1,
      searchValue: "",
    };
  },
  computed: {
    ...mapState({
      token: (state) => state.user.token,
    }),
  },
  methods: {
    onChange() {
      this.$emit("radioChange", this.value);
    },
    onSearch(value) {
      if (!value || regV.test(value)) {
        this.$message.warning("内容不能为空或包含&=字符");
        return;
      }
      this.$emit("handleSearch", value);
    },
    handleClick(value) {
      this.$emit("handleClick", value);
    },
    patentHandleClick(value) {
      this.$emit("patentHandleClick", value);
    },
    async handleMajorSearch() {
      if (!this.token) {
        // this.$message.warning("请先登录");
        window.open(`https://patyee.com/search/advance`);
        return;
      }
      //带参数的检索
      //  if(!this.searchValue || regV.test(this.searchValue)) {
      //    this.$message.warning('内容不能为空或包含&=字符')
      //    return
      //  }
      //  this.$emit('majorSearch', this.searchValue)

      //高级检索不带参数
      const { token, refreshToken } = await getPatyeeToken();
      const page = "/search/advance";

      if (token && refreshToken) {
        window.open(
          `${Pat}?token=${token}&refresh_token=${refreshToken}&redirect=${page}`
        );
      } else {
        window.open(`https://patyee.com/search/advance`);
      }

      //window.open('https://www.patyee.com/search/advance')
    },
    moreClick() {
      this.$emit("handleClick", 5);
    },
  },
};
</script>

<style></style>
